import { render, staticRenderFns } from "./rule_table.vue?vue&type=template&id=aec8a6d0&scoped=true"
import script from "./rule_table.vue?vue&type=script&lang=js"
export * from "./rule_table.vue?vue&type=script&lang=js"
import style0 from "./rule_table.vue?vue&type=style&index=0&id=aec8a6d0&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aec8a6d0",
  null
  
)

export default component.exports